import * as firebase from 'firebase/app';
import { db } from '.';

async function addTestToDB(data, ownerPath) {
  const ownerId = db.doc(ownerPath);
  const docData = {
    ...data,
    ownerId,
    questions: []
  };

  const batch = db.batch();
  const newTestRef = db.collection('tests').doc();
  batch.set(newTestRef, docData);
  batch.update(ownerId, {
    steps: firebase.firestore.FieldValue.arrayUnion(newTestRef)
  });
  await batch.commit();
  return newTestRef;
}

async function getTestFromDB(id) {
  const ref = db.collection('tests').doc(id);
  const snapshot = await ref.get();
  return {
    id,
    ...snapshot.data()
  };
}

async function updateTestInDB(data) {
  const { id, ...docData } = data;
  await db
    .collection('tests')
    .doc(id)
    .update(docData);
}

export default {
  add: addTestToDB,
  get: getTestFromDB,
  update: updateTestInDB
};
